import Relay from 'react-relay';

class AddGroupMemberMutation extends Relay.Mutation {
  getMutation = () => Relay.QL`mutation {addGroupMembers}`;

  getVariables() {
    const members = [{
      id: this.props.contacts.contact.id,
      type: 'Contact',
    }];
    return {
      // id of the fav group no need to specify
      members,
    };
  }
  getFatQuery() {
    return Relay.QL`
      fragment on AddGroupMembersPayload {
        group {
          contacts {
            isFavorite
          }
        }
      }
    `;
  }
  getConfigs() {
    return [{
      type: 'REQUIRED_CHILDREN',
      children: [Relay.QL`
        fragment on AddGroupMembersPayload {
          group {
            contacts {
              isFavorite
            }
          }
        }
      `],
    }];
  }
}

export default AddGroupMemberMutation;



// WEBPACK FOOTER //
// ./src/js/Mutations/AddGroupMemberMutation.js